import React from 'react';
import pt from 'prop-types';

import { StorefrontEditorSidebarIcon } from 'components/storefront/editor/icon';

function BlockLabel({ label }) {
  if (!label) {
    return null;
  }

  return (
    <div className="block-overlay--label">
      <StorefrontEditorSidebarIcon type={label} width={12} height={12} />
      {label}
    </div>
  );
}

BlockLabel.propTypes = {
  label: pt.string,
};

export default React.memo(BlockLabel);
